// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26mCZ","col":"styles_col__3kZvI"};